// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { HistoryType } from '@shared/utils/History/HistoryType';
import QuotePricePickerTemplate from '@front/templates/QuotePricePickerTemplate.html';
import { ContainerControl } from '@front/controls/elements/ContainerControl';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { StringUtils } from '@shared/utils/StringUtils';
export class QuotePricePicker extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return 'QuotePricePicker';
    }
    oninit() {
        super.oninit();
        this.observe('instrument', this.onInstrumentChanged);
        this.observe('quote side account instrument', this.updatePrice);
        this.observe('price', this.onPriceChanged);
        this.on('click', this.pickPrice);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        this.unsubscribeQuotes(this.get('instrument'));
        super.dispose();
    }
    localize() {
        void this.set('label', Resources.getResource('panel.orders.CurrentPrice'));
    }
    onInstrumentChanged(newInstument, oldInstrument) {
        if (isNullOrUndefined(newInstument) || newInstument === oldInstrument) {
            return;
        }
        this.unsubscribeQuotes(oldInstrument);
        this.subscribeQuotes(newInstument);
    }
    subscribeQuotes(instrument) {
        if (isNullOrUndefined(instrument)) {
            return;
        }
        // TODO. Refactor.
        this.newQuote(instrument.LastQuote);
        instrument.DataCache.FQuoteCache.addListener(instrument, this, HistoryType.QUOTE_LEVEL1);
    }
    unsubscribeQuotes(instrument) {
        if (isNullOrUndefined(instrument)) {
            return;
        }
        // TODO. Refactor.
        instrument.DataCache.FQuoteCache.removeListener(instrument, this, HistoryType.QUOTE_LEVEL1);
        this.newQuote(null);
    }
    newQuote(quote) {
        if (quote && quote.Type === HistoryType.QUOTE_INSTRUMENT_DAY_BAR) {
            return;
        }
        void this.set('quote', quote);
    }
    updatePrice() {
        const ins = this.get('instrument');
        const acc = this.get('account');
        const side = this.get('side');
        const quote = this.get('quote');
        if (isNullOrUndefined(quote) || isNullOrUndefined(ins) || isNullOrUndefined(acc)) {
            void this.set('price', null);
            return;
        }
        let price = null;
        if (side === OperationType.Buy) {
            price = quote.AskSpread_SP_Ins(ins.DataCache.GetSpreadPlan(acc), ins);
        }
        else if (side === OperationType.Sell) {
            price = quote.BidSpread_SP_Ins(ins.DataCache.GetSpreadPlan(acc), ins);
        }
        void this.set('price', price);
    }
    onPriceChanged(price) {
        const ins = this.get('instrument');
        void this.set('fPrice', !isNullOrUndefined(ins) && price !== null ? ins.formatPrice(price) : StringUtils.NOT_AVAILABLE);
    }
    pickPrice() {
        this.fire('pickPrice', this.get('price'));
    }
}
ContainerControl.extendWith(QuotePricePicker, {
    template: QuotePricePickerTemplate,
    data: function () {
        return {
            label: '',
            account: null,
            instrument: null,
            side: null,
            quote: null,
            price: null,
            fPrice: '',
            sideColor: ''
        };
    }
});
